import React, { useRef, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import RemotePodLoader from "../components/recording/RemotePodLoader";

const loadRecordingPod = () => import("recordingPod/App");

function getUploadStatusValue(nextStatus) {
  if (typeof nextStatus === "string") return nextStatus;
  if (nextStatus && typeof nextStatus.status === "string") {
    return nextStatus.status;
  }
  return null;
}

export default function RecordingSpirometryRouter(props) {
  const navigate = useNavigate();
  const didRedirectRef = useRef(false);
  const recordingDurationSeconds = props.recordingDurationSeconds ?? 60;
  const variant = props.variant || "RecordingSpirometry";

  const handleUploadStatus = useCallback(
    (nextStatus) => {
      props.onUploadStatus?.(nextStatus);

      // Optional: route away from /recording/spirometry/camera once upload begins
      if (
        getUploadStatusValue(nextStatus) === "uploading" &&
        !didRedirectRef.current
      ) {
        didRedirectRef.current = true;
        navigate("/recording/spirometry", { replace: true });
      }
    },
    [navigate, props],
  );

  return (
    <RemotePodLoader
      load={loadRecordingPod}
      componentProps={{
        ...props,
        variant,
        recordingDurationSeconds,
        onUploadStatus: handleUploadStatus,
        onUploadProgress: props.onUploadProgress,
      }}
    />
  );
}
